(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-statistic/assets/route-statistic.js') >= 0) return;  svs.modules.push('/components/tipsen/route-statistic/assets/route-statistic.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  useRouteMatch = _ReactRouterDOM.useRouteMatch;
const tipsenLazy = svs.components.tipsen.tipsenLazy.tipsenLazy;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const SportEventStatus = svs.components.sport.sportEventCommon.SportEventStatus;
const _React = React,
  useContext = _React.useContext;
const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const useDrawSearchParams = svs.components.tipsen.drawProvider.hooks.useDrawSearchParams;
const useMediaQuery = svs.components.lbUtils.useMediaQuery.useMediaQuery;
const STATISTIC_SIDEBAR_QUERY = svs.components.tipsen.constants.STATISTIC_SIDEBAR_QUERY;
const Sportinfo = svs.components.sportinfo.sportinfo.Sportinfo;
const ContentHandler = svs.components.sportInfo.contentHandler.ContentHandler;
const EmptyNotice = svs.component.tipsenEmptyNotice.EmptyNotice;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const SideNavResize = svs.components.tipsen.sideNavResize.SideNavResize;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux.selectors,
  selectLeagueFromSportEvent = _svs$components$sport.selectLeagueFromSportEvent,
  selectSportEvent = _svs$components$sport.selectSportEvent;
const _svs$components$sport2 = svs.components.sportinfo.matchInfoRedux,
  matchInfoSelectors = _svs$components$sport2.selectors,
  matchInfoUtils = _svs$components$sport2.utils;
const productIds = svs.utils.products.productIds;
const detect = svs.core.detect;
const _ReactRouterDOM2 = ReactRouterDOM,
  useLocation = _ReactRouterDOM2.useLocation;
const getIsNotStarted = svs.components.sportinfo.common.matchState.getIsNotStarted;
const RouteStatistic = _ref => {
  var _sportEvent$sportEven;
  let matchId = _ref.matchId,
    branding = _ref.branding,
    bigStattabAreaClassName = _ref.bigStattabAreaClassName,
    drawNumber = _ref.drawNumber,
    hasMaskedOutcomes = _ref.hasMaskedOutcomes,
    setCoupon = _ref.setCoupon,
    _ref$shouldSaveDrawPa = _ref.shouldSaveDrawParams,
    shouldSaveDrawParams = _ref$shouldSaveDrawPa === void 0 ? false : _ref$shouldSaveDrawPa,
    shouldIncludeExtraStats = _ref.shouldIncludeExtraStats,
    productId = _ref.productId;
  const match = useRouteMatch();
  const _useContext = useContext(DrawContext),
    drawNumberFromContext = _useContext.drawNumber,
    _eventNumber = _useContext.eventNumber,
    productIdFromContext = _useContext.productId;
  const eventNumber = _eventNumber || 1;
  const drawNumberToUse = drawNumber || drawNumberFromContext;
  const productIdToUse = productId || productIdFromContext;
  const searchParams = new URLSearchParams(useDrawSearchParams(productIdToUse, drawNumberToUse, eventNumber, shouldSaveDrawParams));
  const isWideDevice = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  if (!isWideDevice) {
    searchParams.set('openStatistic', '');
  }
  const basePath = match.url.endsWith('/') ? match.url : "".concat(match.url, "/");
  const league = useSelector(state => selectLeagueFromSportEvent(state, matchId));
  const sportEvent = useSelector(state => selectSportEvent(state, matchId));
  const isNotStarted = getIsNotStarted(sportEvent === null || sportEvent === void 0 ? void 0 : sportEvent.sportEventStatus);
  const betEventKey = matchInfoUtils.createBetEventKey(productIdToUse, drawNumberToUse, eventNumber);
  const betEvent = useSelector(state => matchInfoSelectors.selectBetEvent(state, betEventKey));
  const menuOptions = {
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  };
  const classNames = ['route-play-statistic'];
  if (hasMaskedOutcomes && !isNotStarted) {
    classNames.push('pg_route_statistic--hidden');
  }
  return React.createElement(SideNavResize, null, hasMaskedOutcomes && !isNotStarted && React.createElement("div", {
    className: "pg_route_statistic__hidden_info"
  }, React.createElement("div", {
    className: "pg_route_statistic__hidden_info__header"
  }, "Matchen \xE4r or\xE4ttad"), "F\xF6r att inte f\xF6rst\xF6ra sp\xE4nningen s\xE5 d\xF6ljer vi det h\xE4r inneh\xE5llet f\xF6r dig tills matchen blivit r\xE4ttad."), React.createElement("div", {
    className: classNames.join(' ')
  }, React.createElement(ErrorBoundary, null, React.createElement(ContentHandler, {
    matchId: matchId,
    productId: productIdToUse,
    shouldIncludeExtraStats: shouldIncludeExtraStats,
    sportEventStatus: (_sportEvent$sportEven = sportEvent === null || sportEvent === void 0 ? void 0 : sportEvent.sportEventStatus) !== null && _sportEvent$sportEven !== void 0 ? _sportEvent$sportEven : SportEventStatus.NotStarted,
    sportType: league === null || league === void 0 ? void 0 : league.sportType
  }, _ref2 => {
    let menuItems = _ref2.menuItems,
      content = _ref2.content,
      lazyComponentsMap = _ref2.lazyComponentsMap,
      matchStateProps = _ref2.matchStateProps;
    return React.createElement(Sportinfo, {
      activeTabBasePaths: [TipsenModuleGameUrl.SYSTEM, TipsenModuleGameUrl.TIPS_SM, TipsenModuleGameUrl.TIPS_EM, "".concat(TipsenModuleGameUrl.MY_BETS, "/:wagerId(\\d+)"), "".concat(TipsenModuleGameUrl.RESULT, "/:date([0-9]{4}-[0-9]{2}-[0-9]{2})?")],
      appendTabSearchParams: searchParams,
      basePath: basePath,
      branding: branding,
      content: content,
      drawNumber: drawNumberToUse,
      eventNumber: eventNumber,
      eventTypeId: betEvent === null || betEvent === void 0 ? void 0 : betEvent.eventTypeId,
      FallbackComp: EmptyNotice,
      isWideDevice: isWideDevice,
      lazyComponentsMap: lazyComponentsMap,
      lazyLoader: tipsenLazy,
      matchId: matchId,
      matchState: matchStateProps.matchState,
      menuItems: menuItems,
      menuOptions: menuOptions,
      productId: productIdToUse,
      setCoupon: setCoupon,
      sportType: matchStateProps.sportType,
      tabAreaClassName: bigStattabAreaClassName,
      tabComponent: TipsenLink
    });
  }))));
};
setGlobal('svs.components.tipsen.routeStatistic.RouteStatistic', RouteStatistic);

 })(window);